import { globalState } from './ui/global-state';
import { pageReload } from './ui/resource-resolver';
import { sameText } from './ui/string-helper-functions';

// eslint-disable-next-line no-var -- var declared as it is replaced by

globalState().debuggingInfo = globalState().debuggingInfo || {
  usedebugv6: 'false',
  isv6Debugging: false,
  localBuildNumber: '',
  isDebugging: true,
  debugOutofdate: false
};
export function setDebugInformation(alocalBuildNumber: string, localDebugV6: string) {
  globalState().debuggingInfo = {
    usedebugv6: localDebugV6,
    isv6Debugging: localDebugV6 === 'true',
    localBuildNumber: alocalBuildNumber,
    isDebugging: sameText(alocalBuildNumber, 'local', ''),
    debugOutofdate: false
  };
  globalThis.localBuildNumber = alocalBuildNumber;
}

export function isDebugMode(): boolean {
  return globalState().debuggingInfo.isDebugging;
}

export function isv6DebugMode(): boolean {
  return globalState().debuggingInfo.isv6Debugging;
}

export function getLocalBuildNumber(): string {
  return globalState().debuggingInfo.localBuildNumber;
}

export function isDebugForcedOutOfDate(): boolean {
  return globalState().debuggingInfo.debugOutofdate;
}

export function appOutOfDate(buildNumber?: string): boolean {
  if (isDebugForcedOutOfDate()) {
    return true;
  }
  return (
    !sameText(getLocalBuildNumber(), buildNumber ?? globalThis.dealerConfiguration?.apiBuildNumberDisplay) &&
    !isDebugMode()
  );
}

export function getServerBuildNumberDisplay() {
  return globalThis.dealerConfiguration?.apiBuildNumberDisplay ?? '';
}

export async function checkAppOutOfDate() {
  await globalThis.dealerRefreshApiDetails?.();
}

export const outOfDateURL = '/outofdate';
globalThis.forceOutOfDate = (value = true, reRoute = true) => {
  globalState().debuggingInfo.debugOutofdate = value;
  if (reRoute) pageReload();
};

globalThis.isAppOutOfDate = (buildNumber?: string) => {
  return appOutOfDate(buildNumber);
};
